import React from 'react';
import { ParallaxSection } from '../components/ParallaxSection';
import { SectionHeading } from '../components/SectionHeading';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="bg-white min-h-screen" data-id="element-169" data-mp="srkgdudg3z12">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80" height="h-[50vh]" data-id="element-170" data-mp="xpcjlkjjj7kk">
        <h1 className="text-5xl md:text-7xl font-bold font-serif text-white text-center" data-id="element-171" data-mp="10o4ox34g0fd">
          Contact Us
        </h1>
      </ParallaxSection>

      <section className="py-20 px-4 md:px-8" data-id="element-172" data-mp="a01fpu6w8x27">
        <div className="max-w-7xl mx-auto" data-id="element-173" data-mp="9z00ddiuhoeo">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-174" data-mp="eyuvxudkf262">
            {/* Form */}
            <div data-id="element-175" data-mp="ewi6kw5h9piz">
              <SectionHeading title="Get in Touch" subtitle="Ready to discuss your next project? Send us a message." centered={false} data-id="element-176" data-mp="1lf6sxs4nie02" />

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-177" data-mp="r0ey1g3nvu13">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-178" data-mp="mz3e9r7gy30t">
                  <div data-id="element-179" data-mp="mzuw7z85828m">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-180" data-mp="i006w040nkpo">
                      Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="John Doe" data-id="element-181" data-mp="czubq9yjfg2u" />
                  </div>
                  <div data-id="element-182" data-mp="3vfekskxvcwhc">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-183" data-mp="3vciot25l0hvj">
                      Email
                    </label>
                    <input type="email" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="john@company.com" data-id="element-184" data-mp="3lgyx6ry1w5cl" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-185" data-mp="3bqqlfj7364ir">
                  <div data-id="element-186" data-mp="2xuwo7xfod3lh">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-187" data-mp="2xvoin4xjcva6">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-188" data-mp="3pk83ezk4j96o" />
                  </div>
                  <div data-id="element-189" data-mp="3ks89bnqqjai0">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-190" data-mp="3krou4esgz07o">
                      Company
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="Company Name" data-id="element-191" data-mp="h4y6e5v3cu5r" />
                  </div>
                </div>

                <div data-id="element-192" data-mp="2bmzj9xxbov6h">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-193" data-mp="26ltto8yylo16">
                    Project Type
                  </label>
                  <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" data-id="element-194" data-mp="1ix0r3tnu0hxl">
                    <option data-id="element-195" data-mp="1suoz3lag7lxp">Commercial Construction</option>
                    <option data-id="element-196" data-mp="1ss2g8pi3xk06">Industrial Engineering</option>
                    <option data-id="element-197" data-mp="1nuj35sx5bd9t">Renovation</option>
                    <option data-id="element-198" data-mp="349kbf0lmhbb3">Consultation</option>
                    <option data-id="element-199" data-mp="3489811w3a5ki">Other</option>
                  </select>
                </div>

                <div data-id="element-200" data-mp="2z9ftd652g8ir">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-201" data-mp="2z9zawlqt0uw9">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 focus:border-[#C5A55A] focus:ring-1 focus:ring-[#C5A55A] outline-none transition-colors" placeholder="Tell us about your project..." data-id="element-202" data-mp="1dsgqv4p4lwvi" />
                </div>

                <button className="bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-bold text-lg w-full md:w-auto transition-colors" data-id="element-203" data-mp="1rt16xt3npelb">
                  Send Message
                </button>
              </form>
            </div>

            {/* Info */}
            <div className="bg-[#0A0A0A] text-white p-10 md:p-12 h-fit" data-id="element-204" data-mp="25jmuvw7yweq2">
              <h3 className="text-2xl font-bold font-serif mb-8 text-[#C5A55A]" data-id="element-205" data-mp="25iuw6cj2q0vk">
                Contact Information
              </h3>

              <div className="space-y-8" data-id="element-206" data-mp="2fhkgsd2ctzfi">
                <div className="flex items-start gap-4" data-id="element-207" data-mp="2filr2fbjqhw6">
                  <MapPin className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-208" data-mp="2plhgnv9qv27x" />
                  <div data-id="element-209" data-mp="2pjefqg71zoof">
                    <p className="font-bold mb-1" data-id="element-210" data-mp="2km4sn774zp3r">Headquarters</p>
                    <p className="text-gray-400" data-id="element-211" data-mp="2koqvwumzvig6">
                      1234 Construction Blvd
                      <br data-id="element-212" data-mp="2fpntlhyefqbw" />
                      Fort Myers, FL 33901
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-213" data-mp="38cs05rd54cps">
                  <Phone className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-214" data-mp="38ecvhj7a3zop" />
                  <div data-id="element-215" data-mp="33dp8d8m682zr">
                    <p className="font-bold mb-1" data-id="element-216" data-mp="33f8n2us6i5zf">Phone</p>
                    <p className="text-gray-400" data-id="element-217" data-mp="2yldxxbtt0ysy">239-810-9482</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-218" data-mp="2uk2c7he1wxq1">
                  <Mail className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-219" data-mp="3r2hy2nc79elx" />
                  <div data-id="element-220" data-mp="3r4kwnvrf4g29">
                    <p className="font-bold mb-1" data-id="element-221" data-mp="3mc9sggpna83w">Email</p>
                    <p className="text-gray-400" data-id="element-222" data-mp="3maqbenw5zt12">info@sinclaircommercial.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-223" data-mp="1pdknyc01uo7y">
                  <Clock className="w-6 h-6 text-[#C5A55A] shrink-0 mt-1" data-id="element-224" data-mp="1pd18d1xvgbx3" />
                  <div data-id="element-225" data-mp="1anmwnn6tpiej">
                    <p className="font-bold mb-1" data-id="element-226" data-mp="1ao4zj2nzquvf">Hours</p>
                    <p className="text-gray-400" data-id="element-227" data-mp="1fn96rnrcuij4">
                      Mon - Fri: 8:00 AM - 6:00 PM
                      <br data-id="element-228" data-mp="11nqe83b11frx" />
                      Sat - Sun: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="mt-10 w-full h-64 bg-gray-800 rounded-sm flex items-center justify-center relative overflow-hidden group" data-id="element-229" data-mp="rqbw7z9ggixi">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80')] bg-cover bg-center opacity-50 group-hover:opacity-60 transition-opacity" data-id="element-230" data-mp="wpf37p8zwz84" />
                <MapPin className="w-12 h-12 text-[#C5A55A] relative z-10 drop-shadow-lg" data-id="element-231" data-mp="2r2eghbpwlhc8" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}